import { green, grey } from "@material-ui/core/colors";
import { CSSProperties } from "react";

export enum StatusProtest {
    OPEN = "OPEN",
    CLOSED = "CLOSED",
}

export const StatusProtestDescription = {
    OPEN: "Aberto",
    CLOSED: "Fechado",
};

export const StatusProtestColor: { [key: string]: CSSProperties } = {
    OPEN: {
        backgroundColor: green["500"],
        color: "white",
        fontWeight: "bold",
    },
    CLOSED: {
        backgroundColor: grey["500"],
        color: "white",
        fontWeight: "bold",
    },
};

//EVER NEW FIELD IS ADDED TO THIS INTERFACE IT NEEDS TO BE ADDED ON UPDATE RULE FOR PROTEST COLLECTION ON firestore.rules FILE
export interface Protest {
    id: string;
    seasonId: string;
    authorUserId: string;
    authorDriverId: string;
    authorDriverNumber: string;
    championshipId: string;
    roundId: string;
    raceControlId: string;
    raceNumber: number;
    lap: number;
    infractionId: string;
    complaint: string;
    createdAt: string;
    protestedUserId: string;
    protestedDriverId: string;
    protestedDriverNumber: string;
    defense: string;
    defenseAt: string;
    status: StatusProtest;
    raceControlAnswer: string;
}
